<template lang="pug">
v-card(:to="to", max-width="300px", width="100%")
  .pa-4.text-center.text-h6.text-uppercase.white--text.font-weight-bold(
    :class="!expired ? 'primary' : 'grey darken-1'"
  )
    span {{ discipline }}
    v-icon.white--text.mt-n1(v-if="!expired", right) fas fa-calendar-plus
    v-icon.white--text.mt-n1(v-else, right) fas fa-calendar-check
  .px-3.py-2
    .font-weight-bold {{ title }}
    .mt-1 {{ textWithoutHTML }}
    .mt-2(v-if="dateStart")
      .text--secondary.font-weight-bold Solicitado:
      div
        v-icon.mt-n1(left, small) far fa-clock
        span.black--text.font-weight-medium {{ formatDate(dateStart) }}
    .mt-2(v-if="dateEnd")
      .text--secondary.font-weight-bold Entrega:
      div
        v-icon.mt-n1(left, small) far fa-clock
        span.black--text.font-weight-medium {{ formatDate(dateEnd) }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    dateStart: {
      type: String,
      required: true,
    },
    dateEnd: {
      type: String,
      required: true,
    },
    discipline: {
      type: String,
      required: true,
    },
    expired: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    textWithoutHTML() {
      let d = document.createElement("div");
      d.innerHTML = this.text;
      return d.textContent;
    },
  },
  methods: {
    formatDate(v) {
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date(v));
    },
  },
};
</script>
